import AdminUserDetailScreen from '../../../src/screens/AdminUserDetailScreen';

export default function AdminUserDetailRoute() {
  return <AdminUserDetailScreen />;
}
